module.exports = __webpack_public_path__ + "img/gyjh.a9bfb4db.png";